export default {
  direct: 'Direct',
  stops: 'stops',
  stop: 'stop',
}
